import { get } from '@/lib/api';
import { rec, str } from './normalize';

/**
 * Runtime config served by `GET /api/config`. Only production returns a
 * PostHog block; dev and alpha answer `posthog: null` so nothing is loaded.
 * `google` is null unless the server has all three Picker identifiers set.
 */
export interface AppConfig {
  environment: string;
  posthog: { key: string; host: string } | null;
  google: { clientId: string; apiKey: string; appId: string } | null;
}

export async function fetchConfig(signal?: AbortSignal): Promise<AppConfig> {
  const raw = rec(await get<unknown>('/api/config', undefined, signal));
  const ph = raw.posthog && typeof raw.posthog === 'object' ? rec(raw.posthog) : null;
  const key = ph ? str(ph.key) : '';
  const host = ph ? str(ph.host) : '';
  const g = raw.google && typeof raw.google === 'object' ? rec(raw.google) : null;
  const clientId = g ? str(g.clientId) : '';
  const apiKey = g ? str(g.apiKey) : '';
  const appId = g ? str(g.appId) : '';
  return {
    environment: str(raw.environment, 'unknown'),
    posthog: key && host ? { key, host } : null,
    google: clientId && apiKey && appId ? { clientId, apiKey, appId } : null
  };
}
